import { Route } from "react-router-dom";
import * as Sentry from "@sentry/react";

// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);

export default SentryRoute;
